import { memo } from "react";

import { CheckMarkCell } from "app/pages/sales-intelligence/common-components/table-cells";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { LeadsSearchRow, TableRecord } from "../../../types";
import { CrmCellRightBarLogicContainer } from "../CrmCellRightBarLogicContainer";

import { CrmRecordCountCellContainer } from "./CrmRecordCountCellContainer";

type Props = {
    record: TableRecord<LeadsSearchRow>;
    value: number;
    integrationProvider: CrmIntegrationProvider;
};

export const CrmRecordsCellContainer = memo(({ record, value, integrationProvider }: Props) => {
    if (salesSettingsHelper.isCrmCustomFiltersEnabled) {
        return (
            <CrmRecordCountCellContainer
                value={value}
                record={record}
                integrationProvider={integrationProvider}
            />
        );
    }

    const cell = <CheckMarkCell isChecked={value > 0} />;

    if (integrationProvider === "salesforce") {
        return (
            <CrmCellRightBarLogicContainer
                record={record}
                widgetId="salesforceActivity"
            >
                {cell}
            </CrmCellRightBarLogicContainer>
        );
    }

    return cell;
});

CrmRecordsCellContainer.displayName = "CrmRecordsCellContainer";
